module.exports = __webpack_public_path__ + "img/selected1-min.eb6654b5.png";